(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-tabs')) {
    class CollectionTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = this.querySelectorAll('[data-tab]');
        this.panels = this.querySelectorAll('[data-panel]');
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectTab(tab));
        });
      }

      selectTab(activeTab) {
        const activeId = activeTab.dataset.tab;
        this.tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.panel !== activeId;
        });
      }
    }

    customElements.define('collection-tabs', CollectionTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyType = this.getAttribute('data-sticky-type');
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.headerBounds = {};

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      if (this.stickyType === 'always') return;

      this.setHeaderHeight();

      this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
      this.headerMediaQuery.addEventListener('change', this.setHeaderHeightHandler);

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.headerMediaQuery?.removeEventListener('change', this.setHeaderHeightHandler);
      if (!this.onScrollHandler) return;
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('homepage-autoplay-video')) {
    class HomepageAutoplayVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.muteButton = this.querySelector('[data-mute-toggle]');
        if (!this.video) return;

        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.setAttribute('muted', '');
        this.video.setAttribute('playsinline', '');
        this.video.setAttribute('webkit-playsinline', '');
        this.video.playsInline = true;
        this.tryPlay();

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-mute-toggle]')) return;
          this.togglePlay();
        });

        this.muteButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggleMute();
        });

        this.video.addEventListener('play', () => this.updateUI());
        this.video.addEventListener('pause', () => this.updateUI());
        this.video.addEventListener('volumechange', () => this.updateUI());
        this.updateUI();
      }

      tryPlay() {
        const playAttempt = this.video.play();
        if (playAttempt && typeof playAttempt.catch === 'function') {
          playAttempt.catch(() => {});
        }
      }

      togglePlay() {
        if (this.video.paused) {
          this.tryPlay();
        } else {
          this.video.pause();
        }
      }

      toggleMute() {
        this.video.muted = !this.video.muted;
        if (!this.video.muted && this.video.volume === 0) {
          this.video.volume = 1;
        }
        this.updateUI();
      }

      updateUI() {
        this.classList.toggle('is-paused', this.video.paused);
        this.classList.toggle('is-muted', this.video.muted);
        if (this.muteButton) {
          this.muteButton.setAttribute('aria-label', this.video.muted ? 'Unmute video' : 'Mute video');
        }
      }
    }

    customElements.define('homepage-autoplay-video', HomepageAutoplayVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
